import React from "react";
import { Check, Circle } from "lucide-react";

export default function SingleChoiceStep({ options, selectedId, onChange, title, description }) {
  return (
    <div>
      <h3 className="font-heading font-semibold text-white mb-1">{title}</h3>
      <p className="text-sm text-slate-400 mb-4">{description}</p>
      <div className="space-y-2">
        {options.map((o) => {
          const active = selectedId === o.id;
          return (
            <button
              key={o.id} onClick={() => onChange(o.id)} data-testid={`single-choice-option-${o.id}`}
              className={`w-full flex items-center gap-3 p-3.5 rounded-lg border text-left transition-colors ${
                active ? "border-amber-400 bg-amber-400/10" : "border-white/10 bg-white/[0.02] hover:border-white/25"
              }`}
            >
              <div className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 ${active ? "bg-amber-400/20 text-amber-300" : "bg-white/5 text-slate-400"}`}>
                <Circle className="w-3.5 h-3.5" />
              </div>
              <span className="text-sm text-slate-200 flex-1">{o.label}</span>
              {active && <Check className="w-4 h-4 text-amber-400" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
